import clsx from "clsx";
import {
    ClockIcon,
    CogIcon,
    CurrencyDollarIcon,
    GlobeAltIcon,
    MapPinIcon,
    UserIcon,
} from "@heroicons/react/24/solid";

export function PageHeading() {
    return (
        <div className={clsx("pb-8")}>
            <div className="flex justify-between">
                <h1 className="display-s mb-1">Gumps</h1>
            </div>
            <div className="flex flex-wrap gap-6">
                <div className="flex items-center gap-1.5">
                    <ClockIcon className="fill-subdued size-4" />
                    <p className="body-s subdued">Last updated: 07/16/25</p>
                </div>

                <div className="flex items-center gap-1.5">
                    <CogIcon className="fill-subdued size-4" />
                    <p className="body-s subdued">Luxury Retail</p>
                </div>

                <div className="flex items-center gap-1.5">
                    <CurrencyDollarIcon className="fill-subdued size-4" />
                    <p className="body-s subdued">$3M - $5.5M</p>
                </div>

                <div className="flex items-center gap-1.5">
                    <GlobeAltIcon className="fill-subdued size-4" />
                    <p className="body-s subdued">gumps.com</p>
                </div>

                <div className="flex items-center gap-1.5">
                    <MapPinIcon className="fill-subdued size-4" />
                    <p className="body-s subdued">CA</p>
                </div>

                <div className="flex items-center gap-1.5">
                    <UserIcon className="fill-subdued size-4" />
                    <p className="body-s subdued">51-200</p>
                </div>
            </div>
        </div>
    );
}
